import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  justLogout?: boolean;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  justLogout: false,
};

const logout = createSlice({
  name: "logout",
  initialState,
  reducers: {
    logoutStart: (state, action: PayloadAction<{ toastMsg: string }>) => {
      state.status = ReduxStateType.INIT;
    },
    logoutSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
      state.justLogout = true;
    },
    logoutFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.justLogout = false;
    },
    setLogoutState: (state, action) => {
      state.justLogout = action.payload;
    },
  },
});

export const { logoutStart, logoutSuccess, logoutFailed, setLogoutState } =
  logout.actions;

export default logout.reducer;
